import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Link } from "react-router-dom";
import { Queries, Mutations } from "../../../../graphql";
import PropTypes from "prop-types";
import {
  Tabs,
  Typography,
  Spin,
  Row,
  Col,
  Input,
  message,
  Table,
  Icon,
  Button,
  Popconfirm,
  Form,
  Select,
  Radio,
  DatePicker,
  Avatar,
  Modal,
  InputNumber,
  TimePicker,
} from "antd";
import Container from "../../../../components/user/Container";
import FromInput from "../../../../components/user/from/Input";
import axiosAPI from "../../../../config/axiosAPI";
import { checkLinkURL } from "../../../../utils/auth";

// import InputTextArea from '../../../../components/'
//import { checkMoreThanLess, changeFormatdate, getTimeFromMins, changeFormatdateThai } from '../../../../utils/formatdate'
import moment from "moment";
import { NIL } from "uuid";
import ModalConfirmForm from "../../../../components/user/ModalConfirmForm";
import { alertMessage } from "../../../../utils/message";
import {
  profileObjectKey,
  employeeDetailObjectKey,
} from "../../../../utils/auth";
import {
  changeFormatdate,
  changeFormatFulldate,
} from "../../../../utils/formatdate";

import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Tab3 from "./Tab3";
import Tab4 from "./Tab4";
import Tab5 from "./Tab5";
import Tab6 from "./Tab6";
import Tab7 from "./Tab7";
import Tab8 from "./Tab8";
import detail from "../../Hospital/Withdraw/detail";

const { TabPane } = Tabs;
const { Text, Title } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const DOCUMENT_TYPE = [
  { label: "ใบรับรองแพทย์", value: "ใบรับรองแพทย์" },
  //  { label: 'ใบสูติบัตร', value: 'ใบสูติบัตร' },
  { label: "อื่น ๆ", value: "อื่น ๆ" },
];

const newsDataProfile = "";
const format = "HH:mm";

class FormLeaveStudy extends Component {
  state = {
    detailForm: null,
    preLoadOnsubmit: false,
    studyLearnRecord: [],
    deletedStudyLearnRecordId: [],
    loadingFullpage: true,
    dataTermfeeHistory: null
  };

  fetchStudyLeaveRequestById = async () => {
    const { client, location, match } = this.props;
    const { offset, limit, detailForm } = this.state;

    // await this.setState({
    //     preLoadSubmit:true,
    //     loading:true
    // })

    console.log("match.url.split('/')[14]", match.url);
    console.log("match.url.split('/')[14]", match.url.split("/")[5]);

    const { data, errors } = await client.query({
      query: Queries.fetchStudyLeaveRequestById,
      variables: {
        studyLeaveRequestId: match.url.split("/")[5],
      },
    });

    console.log(
      "data.fetchStudyLeaveRequestById",
      data.fetchStudyLeaveRequestById
    );

    if (data.fetchStudyLeaveRequestById) {
      
      await this.setState({
        //dataTalbeUploads: data.fetchLeaveDocumentDetail.attachFiles,
        detailForm: data.fetchStudyLeaveRequestById,
        studyLearnRecord: data.fetchStudyLeaveRequestById.studyLearnRecord
          ? data.fetchStudyLeaveRequestById.studyLearnRecord
          : [],
        
        //leaveTypeId: data.fetchLeaveDocumentDetail.leaveTypeId,
        //leaveTypeCategory: data.fetchLeaveDocumentDetail.durationType,
      });
      await this.getHistoryTermfees(match.url.split("/")[5])
    } else {
      await this.setState({
        loading: false,
        preLoadSubmit: false,
        loadingFullpage: false,
      });
    }
  };

  handleSubmitCancel = async (e) => {
    window.location.href = "/employeeRegistration/LeaveStudies";
    // this.sendToCreateLeave(e, 'DRAFT')
  };

  dateFormatNumber = (values) => {
    let valueReturn = this.props.form.getFieldValue(values);
    return changeFormatdate(moment(valueReturn));
  };

  handleTableChange = (tableValue) => {
    const { studyLearnRecord } = this.state;
    this.setState({ studyLearnRecord: tableValue });
    console.log("tableValue", tableValue);
  };

  deletedStudyLearnRecord = async (RecordId) => {
    const { deletedStudyLearnRecordId } = this.state;
    deletedStudyLearnRecordId.push(RecordId);
    await this.setState({
      deletedStudyLearnRecordId,
    });
  };

  fetchProfile = async () => {
    try {
      const { client } = this.props;
      const { data } = await client.query({
        query: Queries.fetchProfile,
      });

      await this.setState({
        loginPerson: data.fetchProfile,
      });
      // return data.fetchProfile

      console.log("FETCH PROFILE:", data.fetchProfile);
      console.log("FETCH emp:", data.fetchProfile.employeeCodes[0]);
    } catch (e) {}
  };

  fetchDropDownstudyLeaveYear = async () => {
    const { client, location, match } = this.props;
    const { offset, limit, detailForm, dropDownYear } = this.state;
    let dropDownRetrue = [];

    console.log("fetchDropDownstudyLeaveYear");
    await this.setState({
      preLoadSubmit: true,
      loading: true,
    });

    const { data, errors } = await client.query({
      query: Queries.dropDownstudyLeaveYear,
      variables: {
        studyLeaveRequestId: match.url.split("/")[5],
      },
    });

    // await data.dropDownstudyLeaveYear.map((values, keys) => {
    //   dropDownRetrue.push({
    //     value: values.value,
    //     label: values.label,
    //   });
    // });

    if (data.dropDownstudyLeaveYear) {
      await this.setState({
        preLoadSubmit: false,
        loading: false,
      });
    }

    await this.setState({
      dropDownYear: data.dropDownstudyLeaveYear,
    });
    // return data.fetchProfile

    console.log("FETCH dropDownstudyLeaveYear", data.dropDownstudyLeaveYear);
    // console.log("FETCH dropDownstudyLeaveYear retrue:", dropDownRetrue);
  };

  showModalFormConfirm = async (values, messageShow, title, textBtnOK) => {
    const { form, client } = this.props;

    await this.setState({
      ModalConfirmFormTitle: messageShow,
      ModalConfirmFormSubTitle: title,
      ModalConfirmFormShowModal: true,
      ModalConfirmFormBtnOk: textBtnOK,
      ModalConfirmFormBtnCancel: "ยกเลิก",
      ModalConfirmFormValue: values,
    });
  };

  hideModalConfirm = async () => {
    await this.setState({
      ModalConfirmFormTitle: null,
      ModalConfirmFormSubTitle: null,
      ModalConfirmFormShowModal: false,
      ModalConfirmFormBtnOk: null,
      ModalConfirmFormBtnCancel: null,
      ModalConfirmFormValue: null,
    });
  };

  handleSubmit = async (e) => {
    //console.log("STRATNAME all", values);
    const { form } = this.props;
    const { studyLearnRecord } = this.state;
    let error = false;
    let checkModal = false;
    e.preventDefault();

    console.log("handle submit e", e);

    const fieldsHandle = form.getFieldsValue();
    //const { studyRecord } = fields
    console.log("studyRecord fieldsHandle", fieldsHandle);

    form.validateFields(async (err, values) => {
      console.log("err", err);
      console.log("handle submit values", values);
      if (err) {
        Modal.error({
          className: "modalFickIcons",
          title: "ส่งดำเนินการไม่สำเร็จ",
          width: "600px",
          content: (
            <h3 className="mt-3">กรุณาระบุข้อมูลผลการศึกษาให้ครบถ้วน</h3>
          ),
          okText: "ปิด",
          onOk() {},
        });
      } else {
        let errorYear = false;
        console.log("errorYear studyLearnRecord", studyLearnRecord);
        console.log("errorYear before", errorYear);
        if (studyLearnRecord.length !== 0) {
          console.log("errorYear studyLearnRecord length hi");

          var valueArr = studyLearnRecord.map(function (item) {
            return {
              studyLearnYear: item.studyLearnYear,
              studyLearnTerm: item.studyLearnTerm,
            };
          });

          var checkDuplicateArray = valueArr.filter(
            (v, i, a) =>
              a.findIndex(
                (t) =>
                  t.studyLearnYear === v.studyLearnYear &&
                  t.studyLearnTerm === v.studyLearnTerm
              ) === i
          );

          // studyLearnRecord.map(async (valuesFile, keyValuesFile) =>
          // valuesFile
          //             const prevRecord = arr[keyValuesFile - 1];
          //  console.log(" errorYear prevRecord",prevRecord)
          // console.log(" errorYear valuesFile[keyValuesFile]", valuesFile)
          //             // if (
          //             //   prevRecord?.studyLearnYear &&
          //             //   valuesFile[keyValuesFile].studyLearnYear == prevRecord.studyLearnYear &&
          //             //   prevRecord?.studyLearnTerm &&
          //             //   valuesFile[keyValuesFile].studyLearnTerm == prevRecord.studyLearnTerm
          //             // ) {
          //             //   errorYear = true;
          //             //   console.log("errorYear true case")
          //             // }
          // ).filter((a,i)=>a.studyLearnYear == );

          let returnArray = [];
          let returnNoValidate = false;

          if (studyLearnRecord.length !== 0) {
            // studyLearnRecord.map(async (valuesFile, keyValuesFile) => {
            //   if (!valuesFile.studyLearnRecordId) {
            //     if (!valuesFile.file) {
            //       //document.getElementById('showTextUplodas'+keyValuesFile).classList.add("color-red")
            //       checkModal = true;
            //     }
            //   }
            // });
            if (studyLearnRecord?.length > 0) {
              studyLearnRecord.map((valueReturn, keys) => {
                if (valueReturn.studyLearnRecordId) {
                  returnArray.push(valueReturn);
                } else {
                  if (valueReturn.isValidate) {
                    delete valueReturn.isValidate;
                    returnArray.push(valueReturn);
                  } else {
                    returnNoValidate = true;
                  }
                }
              });
              await this.setState({
                studyLearnRecord: returnArray,
              });
            }
          }

          if (checkDuplicateArray.length != studyLearnRecord.length) {
            console.log("isDuplicate hi");
            Modal.error({
              className: "modalFickIcons",
              title: "ส่งดำเนินการไม่สำเร็จ",
              width: "600px",
              content: (
                <h3 className="mt-3">
                  ไม่สามารถบันทึกภาคการศึกษาและปีการศึกษาซ้ำได้
                </h3>
              ),
              okText: "ปิด",
              onOk() {},
            });
          } else if (checkModal) {
            Modal.error({
              title: "กรุณาอัปโหลดรูปภาพหรือไฟล์",
              className: "custom-modal-error",
              okText: "ตกลง",
            });
            await this.setState({
              preLoadOnsubmit: false,
              loadingFullpage: false,
            });
          } else if (returnNoValidate) {
            console.log("actionSubmit return no validate");
            Modal.error({
              className: "modalFickIcons",
              title: "ส่งดำเนินการไม่สำเร็จ",
              width: "600px",
              content: (
                <h3 className="mt-3">มีข้อมูลผลการศึกษาที่ยังไม่ถูกบันทึก</h3>
              ),
              okText: "ปิด",
              onOk() {},
            });
          } else {
            try {
              await this.showModalFormConfirm(
                values,
                "ท่านต้องการบันทึก?",
                "",
                "บันทึก"
              );
            } catch (error) {
              await this.setState({
                preLoadOnsubmit: false,
                // loadingFullpage: false
              });
              console.log("error", error);
            }
          }
        } else {
          try {
            await this.showModalFormConfirm(
              values,
              "ท่านต้องการบันทึก?",
              "",
              "บันทึก"
            );
          } catch (error) {
            await this.setState({
              preLoadOnsubmit: false,
              // loadingFullpage: false
            });
            console.log("error", error);
          }
        }
      }
    });
  };

  sendToCreateLeaveDoc = async (values) => {
    const { form, client, match } = this.props;
    const {
      dropdownApproverMedical,
      //dataTalbeUploads,
      detailProfile,

      reqAttachDay,
      leaveDay,
      ModalConfirmFormStatus,
      shiftId,
      leaveHour,
      detailForm,
      studyLearnRecord,
      deletedStudyLearnRecordId,
      loginPerson,
    } = this.state;

    // this.setState({
    //     preLoadOnsubmit: true,
    //     loadingFullpage: true
    // })

    await this.hideModalConfirm();

    try {
      let approversDropDown = [];
      let attachFiles = [];
      let checkModal = false;
      let learnRecord = [];
      let studyHistory = [];

      // console.log("sendToCreateLeaveDoc")
      console.log("studyLearnRecord sendtocreate", studyLearnRecord);
      if (studyLearnRecord.length !== 0) {
        studyLearnRecord.map(async (valuesFile, keyValuesFile) => {
          delete valuesFile.createdAt;
          delete valuesFile.createdBy;
          //  delete valuesFile.studyLearnRecordId;
          delete valuesFile.studyLearnRecordRefId;
          //  delete valuesFile.studyLeaveRequestId;
          delete valuesFile.updatedAt;
          delete valuesFile.updatedBy;

          // if (valuesFile.fileId) {
          //   // if (valuesFile.file) {
          //   //   const fileTwoBase64 = valuesFile.base64;
          //   //   const formAttachFile = this.base64ToBlob(
          //   //     fileTwoBase64,
          //   //     valuesFile.fileType,
          //   //     valuesFile.fileName
          //   //   );
          //   //   valuesFile.file = formAttachFile;

          //   //   if (
          //   //     valuesFile.studyLearnTerm ||
          //   //     valuesFile.studyLearnYear ||
          //   //     valuesFile.studyLearnGPAX ||
          //   //     valuesFile.createdAt ||
          //   //     valuesFile.studyLearnRemark ||
          //   //     valuesFile.studyLearnGrade
          //   //   ) {
          //   //     let dataArray = {
          //   //       studyLearnTerm: valuesFile.studyLearnTerm
          //   //         ? valuesFile.studyLearnTerm
          //   //         : "",
          //   //       studyLearnYear: valuesFile.studyLearnYear
          //   //         ? valuesFile.studyLearnYear
          //   //         : "",
          //   //       studyLearnGPAX: valuesFile.studyLearnGPAX
          //   //         ? valuesFile.studyLearnGPAX
          //   //         : "",
          //   //       createdAt: valuesFile.createdAt ? valuesFile.createdAt : "",
          //   //       studyLearnRemark: valuesFile.studyLearnRemark
          //   //         ? valuesFile.studyLearnRemark
          //   //         : "",
          //   //       studyLearnGrade: valuesFile.studyLearnGrade
          //   //         ? valuesFile.studyLearnGrade
          //   //         : "",
          //   //       file: valuesFile.file ? valuesFile.file : null,
          //   //     };

          //   //     learnRecord.push(dataArray);
          //   //   }
          //   // }
          // }
          //else {
          if (!valuesFile.studyLearnRecordId) {
            if (
              valuesFile.studyLearnTerm ||
              valuesFile.studyLearnYear ||
              valuesFile.studyLearnGPAX ||
              valuesFile.createdAt ||
              valuesFile.studyLearnRemark ||
              valuesFile.studyLearnGrade
            ) {
              //   if(!valuesFile.file){
              //     //document.getElementById('showTextUplodas'+keyValuesFile).classList.add("color-red")
              //     checkModal = true
              //  }

              let dataArray = {
                studyLearnTerm: valuesFile.studyLearnTerm
                  ? valuesFile.studyLearnTerm
                  : "",
                studyLearnYear: valuesFile.studyLearnYear
                  ? valuesFile.studyLearnYear
                  : "",
                studyLearnGPAX: valuesFile.studyLearnGPAX
                  ? valuesFile.studyLearnGPAX
                  : "",
                //createdAt: valuesFile.createdAt ? valuesFile.createdAt : "",
                studyLearnRemark: valuesFile.studyLearnRemark
                  ? valuesFile.studyLearnRemark
                  : "",
                studyLearnGrade: valuesFile.studyLearnGrade
                  ? valuesFile.studyLearnGrade
                  : "",
                studyLearnReview: valuesFile.studyLearnReview
                  ? valuesFile.studyLearnReview
                  : "pending_review",
                studyLearnReviewAt: valuesFile.studyLearnReviewAt
                  ? valuesFile.studyLearnReviewAt
                  : null,
                studyLearnReviewBy: valuesFile.studyLearnReviewBy
                  ? valuesFile.studyLearnReviewBy
                  : "-",
                studyLearnReviewRemark: valuesFile.studyLearnReviewRemark
                  ? valuesFile.studyLearnReviewRemark
                  : "",
                file: valuesFile.file ? valuesFile.file : null,
              };

              learnRecord.push(dataArray);
              console.log("learnrecord", learnRecord);
            }
          }

          // }
          delete valuesFile.studyFileName;
          delete valuesFile.studyFileType;
          delete valuesFile.studyFilePath;
          delete valuesFile.__typename;
        });

        let studyHistoryData = {
          studyHistoryAction: "บันทึกผลการศึกษา",
          studyHistoryActionBy: detailForm?.empName,
          studyHistoryActionDatetime: moment(),
          studyHistoryRemark: "-",
          studyHistoryStatus: "บันทึก",
        };

        studyHistory.push(studyHistoryData);
      }

      let valuesFormSend = {
        studyLeaveRequestId: match.url.split("/")[5],
        empCode: detailForm?.empCode,
        empName: detailForm?.empName,
        position: detailForm?.position,
        empSalary: detailForm?.empSalary,
        empGroup: detailForm?.empGroup,
        departmentName: detailForm?.departmentName,
        organizationCode: detailForm?.organizationCode,
        organizationName: detailForm?.organizationName,
        empLevel: detailForm?.empLevel,
        divisionName: detailForm?.divisionName,
        studyLeaveNo: detailForm?.studyLeaveNo,
        studyLeaveDocumentNo: detailForm?.studyLeaveDocumentNo,
        studyLeaveDocumentDate: detailForm?.studyLeaveDocumentDate,
        studyLeaveResult: detailForm?.studyLeaveResult,
        currentRevision: detailForm?.currentRevision,
        studyLeaveStatus: detailForm?.studyLeaveStatus,
        studyLeaveRemark: detailForm?.studyLeaveRemark,
        studyLearnRecord: learnRecord,
        studyHistory: studyHistory,
        isCancel: false,
        isAdmin: false,
        deletedStudyLearnRecordId,
        subDeptCode: detailForm?.subDeptCode,
        subDeptName: detailForm?.subDeptName,
        childSubDeptCode: detailForm?.childSubDeptCode,
        childSubDeptName: detailForm?.childSubDeptName,
      };

      console.log("valuesFormSend", valuesFormSend);

      //if (studyLearnRecord.length !== 0) {
      const { data, errors } = await client.mutate({
        mutation: Mutations.updateStudyLeaveRequest,
        variables: {
          ...valuesFormSend,
        },
      });

      console.log("data", data);
      if (data) {
        message.success("ดำเนินการสำเร็จ");

        await this.setState({
          preLoadOnsubmit: false,
          loadingFullpage: false,
        });
        setTimeout(() => {
          window.location.href = "/employeeRegistration/LeaveStudies";
        }, 1000);
      } else {
        await this.setState({
          preLoadOnsubmit: false,
          loadingFullpage: false,
        });
      }

      //}
    } catch (error) {
      await this.setState({
        preLoadOnsubmit: false,
        loadingFullpage: false,
      });

      console.log("error", error);
    }
  };

  dateFormatNumber = (values) => {
    let valueReturn = this.props.form.getFieldValue(values);
    return changeFormatdate(moment(valueReturn));
  };

   getHistoryTermfees = async (studyLeaveRequestId) => {
      const { client, location, match } = this.props;
      const { empCode } = this.state;
  
      let idDetail = {
        studyLeaveRequestId: studyLeaveRequestId,
      };

      try {
  
        const DataFetchAPI = await axiosAPI.get(
          `${checkLinkURL()}/getStudyEducationFeePaidHistory`,
          { params: { ...idDetail } }
        );
  
        console.log("DataFetchAPI history", DataFetchAPI);
  
        if (DataFetchAPI.data.data) {
          await this.setState({
            dataTermfeeHistory: DataFetchAPI.data.data,
            loadingFullpage: false,
          });
        } else {
        }
      } catch (error) {
        console.log("error", error);
      }
    };


  async componentDidMount() {
    await this.fetchDropDownstudyLeaveYear();
    await this.fetchStudyLeaveRequestById();
    await this.fetchProfile();
  }

  render() {
    const { match } = this.props;
    const { getFieldDecorator } = this.props.form;
    const {
      detailForm,
      dropDownYear,
      preLoadOnsubmit,
      ModalConfirmFormTitle,
      ModalConfirmFormSubTitle,
      ModalConfirmFormShowModal,
      ModalConfirmFormBtnOk,
      ModalConfirmFormBtnCancel,
      ModalConfirmFormValue,
      loadingFullpage,
      dataTermfeeHistory
    } = this.state;

    console.log("detailForm", detailForm);

    return (
      <Container match={match}>
        <div className="breadcrumb-custom pb-3 mb-5">
          {/* <Breadcrumb.Item> */}
          <span style={{ fontSize: "18px" }}>การศึกษา / ดูเอกสารการศึกษา </span>
          {/* </Breadcrumb.Item> */}
        </div>
        <ModalConfirmForm
          title={ModalConfirmFormTitle}
          subtitle={ModalConfirmFormSubTitle}
          showModal={ModalConfirmFormShowModal}
          btnOk={ModalConfirmFormBtnOk}
          btnCancel={ModalConfirmFormBtnCancel}
          submitToSend={this.sendToCreateLeaveDoc}
          hideModal={this.hideModalConfirm}
          valueConfirm={ModalConfirmFormValue}
        />
        <Spin spinning={loadingFullpage} delay={500}>
          {detailForm ? (
            <div className="card-container h-100" id="page-profile">
              <Form
                ref={this.formRef}
                //</div>onSubmit={this.handleSubmit}
              >
                <div className="px-5 pt-1 pb-4 card-bg-green">
                  <Row
                    gutter={16}
                    type="flex"
                    justify="left"
                    align="top"
                    className="box-color-white"
                  >
                    <Col xs={24} md={24} className="pt-2">
                      <strong className="color-red">ข้อมูลเอกสาร</strong>
                    </Col>

                    <Col xs={24} md={12} className="pt-2 mb-1">
                      <FromInput
                        disabled={true}
                        value={detailForm?.studyLeaveNo}
                        required={true}
                        name={"name"}
                        label="เลขที่ข้อมูล"
                        mode={"text"}
                      />
                    </Col>

                    <Col xs={24} md={12} className="pt-2 mb-1">
                      {console.log(
                        "detailForm studyLeaveNo",
                        detailForm?.studyLeaveNo
                      )}
                      <FromInput
                        disabled={true}
                        value={detailForm?.studyLeaveDocumentNo}
                        required={false}
                        name={"deptName"}
                        label="เลขหนังสืออนุมัติ"
                        mode={"text"}
                      />
                    </Col>
                    <Col xs={24} md={12} className="pt-2 mb-1">
                      <FromInput
                        disabled={true}
                        value={detailForm?.studyLeaveDocumentApprove}
                        required={false}
                        name={"studyLeaveDocumentApprove"}
                        label="อนุมัติโดย"
                        mode={"text"}
                      />
                    </Col>

                    <Col xs={24} md={12} className="pt-2 mb-1">
                      {/* <Form.Item label={"วันที่อนุมัติ"} className="mb-0">
                        {getFieldDecorator("studyLeaveDocumentDate", {
                          initialValue: moment(
                            detailForm?.studyLeaveDocumentDate
                          ),
                          //    rules:  [{
                          //       required:true,
                          //       message: 'กรุณาระบุ  วันที่ยื่นเรื่อง',
                          //    }],
                        })(
                          <DatePicker
                            format={this.dateFormatNumber(
                              "studyLeaveDocumentDate"
                            )}
                            placeholder=""
                            style={{ width: "100%" }}
                            disabled={true}
                            //value={detailForm?.studyLeaveDocumentDate}
                          />
                        )}
                      </Form.Item> */}
                      <FromInput
                        disabled={true}
                        value={
                          detailForm?.studyLeaveDocumentDate
                            ? changeFormatdate(
                                detailForm?.studyLeaveDocumentDate
                              )
                            : "-"
                        }
                        required={false}
                        name={"studyLeaveDocumentDate"}
                        label="วันที่อนุมัติ"
                        mode={"text"}
                      />
                    </Col>

                    <Col xs={24} md={12} className="pt-2 mb-1">
                      <Form.Item label={"ประเภทการลาศึกษา"} className="mb-0">
                        {
                          // getFieldDecorator("hospitalName", {
                          //     initialValue: "",
                          //     rules:  [{
                          //         required: true,
                          //         message: 'กรุณาระบุ ชื่อสถานพยาบาล',
                          //     }],
                          // })(
                          <Select
                            disabled={true}
                            style={{ width: "100%" }}
                            value={detailForm?.studyLeaveTypeName}
                            // onChange={ (e) => this.onChangeHospitalDetail(e) }
                          ></Select>
                          // )
                        }
                      </Form.Item>
                    </Col>

                   

                    <Col xs={24} md={12} className="pt-2 mb-1">
                      <Form.Item label={"สถานะการศึกษา"} className="mb-0">
                        {
                          // getFieldDecorator("hospitalName", {
                          //     initialValue: "",
                          //     rules:  [{
                          //         required: true,
                          //         message: 'กรุณาระบุ ชื่อสถานพยาบาล',
                          //     }],
                          // })(
                          <Select
                            disabled={true}
                            style={{ width: "100%" }}
                            value={detailForm?.leaveResultName}
                            // onChange={ (e) => this.onChangeHospitalDetail(e) }
                          ></Select>
                          // )
                        }
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12} className="pt-2 mb-1">
                        <FromInput
                          disabled={true}
                          value={
                            detailForm?.studyLeaveHrDate
                              ? changeFormatdate(detailForm?.studyLeaveHrDate)
                              : "-"
                          }
                          required={false}
                          name={"studyLeaveHrDate"}
                          label="รอบการนำส่งค่าตอบแทน"
                          mode={"text"}
                        />
                      </Col>


                    {
                      detailForm?.studyLeaveResult == "complete" &&
                      <Col xs={24} md={12} className="pt-2 mb-1">
                        <FromInput
                          disabled={true}
                          value={
                            detailForm?.graduationDate
                              ? changeFormatdate(detailForm?.graduationDate)
                              : "-"
                          }
                          required={false}
                          name={"graduationDate"}
                          label="วันที่จบการศึกษา"
                          mode={"text"}
                        />
                      </Col>
                    }

                    <Col xs={24} md={12} className="pt-2 mb-1">
                      <FromInput
                        disabled={true}
                        value={detailForm?.requestName}
                        required={false}
                        name={"diviName"}
                        label="ผู้สร้างข้อมูล"
                        mode={"text"}
                      />
                    </Col>

                    <Col xs={24} md={12} className="pt-2 mb-1">
                      <Form.Item label={"วันที่สร้างข้อมูล"} className="mb-0">
                        {getFieldDecorator("createdAt", {
                          initialValue: moment(detailForm?.createdAt),
                          //    rules:  [{
                          //       required:true,
                          //       message: 'กรุณาระบุ  วันที่ยื่นเรื่อง',
                          //    }],
                        })(
                          <DatePicker
                            format={this.dateFormatNumber("createdAt")}
                            placeholder=""
                            style={{ width: "100%" }}
                            disabled={true}
                            //value={detailForm?.studyLeaveDocumentDate}
                          />
                        )}
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row
                    gutter={16}
                    type="flex"
                    justify="left"
                    align="top"
                    className="box-color-white"
                  >
                    <Col xs={24} md={24} className="pt-2">
                      {console.log("detailForm props", detailForm)}
                      <Tabs
                        type="card"
                        detailForm={{ detailForm }}
                        defaultActiveKey="4"
                      >
                        <TabPane
                          tab="ข้อมูลการลา"
                          key="1"
                          className="py-5 px-4"
                        >
                          <Tab1 detailForm={detailForm} forceRender />
                        </TabPane>
                        <TabPane
                          tab="ข้อมูลทุน/สัญญา"
                          key="2"
                          className="py-5 px-4"
                          forceRender
                        >
                          <Tab2 detailForm={detailForm} forceRender />
                        </TabPane>
                        <TabPane
                          tab="ข้อมูลวันลา"
                          key="3"
                          className="py-5 px-4"
                        >
                          <Tab3 detailForm={detailForm} forceRender />
                        </TabPane>
                        <TabPane tab="ผลการศึกษา" key="4" className="py-5 px-4">
                          {console.log("dropdownYear Tab", dropDownYear)}
                          <Tab4
                            detailForm={detailForm}
                            onTableChange={this.handleTableChange}
                            onChangeDeletedStudyLearnRecord={
                              this.deletedStudyLearnRecord
                            }
                            dropDownYear={dropDownYear}
                            propFormInput={this.props.form}
                            forceRender
                          />
                        </TabPane>
                        <TabPane
                          tab="การเบิกค่าธรรมเนียมการศึกษา"
                          key="5"
                          className="py-5 px-4"
                        >
                          <Tab5 detailForm={detailForm} dataTermfeeHistory={dataTermfeeHistory} forceRender />
                        </TabPane>
                        <TabPane tab="เอกสารแนบ" key="6" className="py-5 px-4">
                          <Tab6 detailForm={detailForm} forceRender />
                        </TabPane>
                        <TabPane tab="หมายเหตุ" key="8" className="py-5 px-4">
                          <Tab8 detailForm={detailForm} forceRender />
                        </TabPane>
                        <TabPane
                          tab="ประวัติการดำเนินการ"
                          key="7"
                          className="py-5 px-4"
                        >
                          <Tab7 detailForm={detailForm} forceRender />
                        </TabPane>
                      </Tabs>
                    </Col>
                  </Row>

                  <Row
                    gutter={16}
                    type="flex"
                    justify="left"
                    align="top"
                    className=""
                  >
                    <Col xs={24} md={24} className="pt-2" align="center">
                      <Button
                        type="primary"
                        className="mx-2 btn-white-red"
                        onClick={this.handleSubmitCancel}
                        disabled={preLoadOnsubmit}
                      >
                        ย้อนกลับ
                      </Button>
                      <Button
                        type="primary"
                        className="ml-2 color-white"
                        //htmlType="submit"
                        disabled={preLoadOnsubmit}
                        onClick={this.handleSubmit}
                      >
                        ยืนยัน
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Form>
            </div>
          ) : (
            ""
          )}
          {/* <Spin spinning={false} delay={500}> */}
        </Spin>
      </Container>
    );
  }
}

FormLeaveStudy.defaultProps = {
  autoFocus: false,
};

FormLeaveStudy.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedFormLeaveStudy = Form.create()(FormLeaveStudy);

export default withApollo(WrappedFormLeaveStudy);
